import styles from './SimilaritiesByPersonHeader.module.scss';

interface ISimilaritiesByPersonHeaderProps {
  title: string;
}

export const SimilaritiesByPersonHeader = ({ title }: ISimilaritiesByPersonHeaderProps) => {
  return (
    <>
      <div className={styles.SimilaritiesHeader}>
        {title && (
          <div className={styles.Content}>
            <div className={styles.Label}>{title}</div>
          </div>
        )}
      </div>
    </>
  );
};
